module.exports = __webpack_public_path__ + "img/zjl.72ebe8f9.png";